import { render, staticRenderFns } from "./canvas.vue?vue&type=template&id=26531618&"
import script from "./canvas.vue?vue&type=script&lang=js&"
export * from "./canvas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports